var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReverseLeft = function SvgReverseLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#60646C",
    fillRule: "evenodd",
    d: "M5.805 1.53c.26.26.26.682 0 .942L4.276 4.001h5.057a4.667 4.667 0 1 1 0 9.333H2.667a.667.667 0 0 1 0-1.333h6.666a3.333 3.333 0 0 0 0-6.667H4.276l1.529 1.529a.667.667 0 1 1-.943.942L2.195 5.14a.667.667 0 0 1 0-.943L4.862 1.53c.26-.26.682-.26.943 0",
    clipRule: "evenodd"
  })));
};
export default SvgReverseLeft;